import commonWatchers from './common'
import errorWatchers from './errors'
import performanceWatchers from './performance'
import settingsWatchers from './settings'
import setupformWatchers from './setupform'
import cropperWatchers from './cropper'
import homeWatchers from './home'
import eventGroupWatchers from './event-group'
import eventGroupDetailsWatchers from './event-group-details'
import signupWatchers from './signup'
import gridWatchers from './grid'
import promoCodeWatchers from './promo-code'

export default function* root() {
  yield commonWatchers
  yield errorWatchers
  yield performanceWatchers
  yield settingsWatchers
  yield setupformWatchers
  yield cropperWatchers
  yield homeWatchers
  yield eventGroupWatchers
  yield eventGroupDetailsWatchers
  yield signupWatchers
  yield gridWatchers
  yield promoCodeWatchers
}



/** WEBPACK FOOTER **
 ** ./src/sagas/index.js
 **/